import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { getInstanceDisplayName, isRocketInstance } from '@/config/instanceProfile'

const displayName = getInstanceDisplayName()
document.title = displayName
const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]')
if (appleTitle) appleTitle.setAttribute('content', displayName)

if (isRocketInstance) {
  document.documentElement.style.setProperty('--brand-primary', '#d4146a')
  document.documentElement.style.setProperty('--brand-primary-muted', 'rgba(212, 20, 106, 0.15)')
  const themeColor = document.querySelector('meta[name="theme-color"]')
  if (themeColor) themeColor.setAttribute('content', '#f8f8fa')
}

const root = document.getElementById('root')
if (!root) throw new Error('Root element não encontrado')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
